export const TRANSFER_CERTIFICATES =
  'TRANSFERRING_CERTIFICATES_TRANSFER_CERTIFICATES';
export const TRANSFER_GOS_CERTIFICATES =
  'TRANSFERRING_GOS_CERTIFICATES_TRANSFER_CERTIFICATES';
export const EXPORT_CERTIFICATES =
  'TRANSFERRING_CERTIFICATES_EXPORT_CERTIFICATES';
export const SELECT_TRANSFER_ROWS = 'SELECT_TRANSFER_ROWS';
export const GET_COUNTRIES_AND_REGISTRIES = 'GET_COUNTRIES_AND_REGISTRIES';
